import { create } from "zustand";
import { persist } from "zustand/middleware";

type State = {
  user: any;
};

type Action = {
  setUser: (user: State["user"]) => void;
  clearUser: () => void;
};

const useUserStore = create<State & Action>()(
  persist(
    (set) => ({
      user: {},
      setUser: (user) => set({ user }),
      clearUser: () => set({ user: {} }),
    }),
    {
      name: 'user-storage', // unique name for localStorage key
      partialize: (state) => ({ user: state.user }), // only persist user data
    }
  )
);

export default useUserStore;
